import React from 'react';
import { useMediaQuery } from 'react-responsive';
import { useTranslation } from 'react-i18next';

// Constants
import MEDIA_QUERIES from '../../constants/media-queries.json';

function Hero() {
  const { t, ready: translationLoaded } = useTranslation('self-service/hero');

  const mediaView = useMediaQuery(MEDIA_QUERIES.fullViewHero);

  //
  // Render

  return (
    <>
      {mediaView && translationLoaded && (
        <header className="hero-text--media">
          <h1 className="hero__text--media__headline">{t('headline')}</h1>
          <p className="hero__text--media">{t('subheadline')}</p>
        </header>
      )}
      <div className="hero__container">
        <div alt="1 on 1 Tutoring" className="hero__image" />
        {!mediaView && translationLoaded && (
          <header className="hero-text">
            <h1 className="hero-text__headline">{t('headline')}</h1>
            <p className="hero-text__subheadline">{t('subheadline')}</p>
          </header>
        )}
      </div>
    </>
  );
}

export default Hero;
